import { Box, Typography } from "@mui/material";
import React from "react";

const FieldErrorMessage = ({ error }) => {
  return (
    <Box>
      {error && (
        <Typography variant="subtitle2" color="error">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default FieldErrorMessage;
